import React from 'react';

export default function Loading(props) {
    let className = 'loading-wrapper';
    if (props.inline) {
        className = `${className} loading-inline`;
    }
    let subClassName = 'loading';
    if (props.invert) {
        subClassName = `${subClassName} inverted`;
    }
    return (
        <span className={className}>
            <span className={subClassName}></span>
        </span>
    );
}
